/**
 * Session 23 — running per-transaction cost (OCPP 2.0.1 CostUpdated).
 * In-memory: the CSMS pushes a total cost for an ongoing transaction and the
 * ConnectorRow shows it next to the active tx. Cleared values fall away when
 * the tab reloads (consistent with the in-memory connector status).
 */
import { create } from 'zustand';

export interface CostStoreState {
  readonly costByTx: ReadonlyMap<number, number>;
}

export interface CostStoreActions {
  setCost(transactionId: number, totalCost: number): void;
  clear(): void;
}

export type CostStore = CostStoreState & CostStoreActions;

export const useCostStore = create<CostStore>((set) => ({
  costByTx: new Map<number, number>(),
  setCost(transactionId: number, totalCost: number): void {
    set((s) => {
      const next = new Map(s.costByTx);
      next.set(transactionId, totalCost);
      return { costByTx: next };
    });
  },
  clear(): void {
    set({ costByTx: new Map() });
  },
}));
